<template>
    <div class="promotionFooterCont">
        <div class="promotionFooter">
            <div class="promotionFooterNav"  :class="{active: (currentNavText == 'center' || currentNavText == null)}" @click="jumpPromotionCenterHandle()">             
               <img v-if="currentNavText == 'center' || currentNavText == null" src="../../../assets/images/agentManage/tuiguang_no_active.png"/>
               <img v-else src="../../../assets/images/agentManage/tuiguang_no_active1.png"/>
                <p>推广中心</p>
            </div>
            <div class="promotionFooterNav"   :class="{active: currentNavText == 'mine'}" @click="jumpMineHandle()">
                <img v-if="currentNavText == 'mine'" src="../../../assets/images/agentManage/mine_active.png"/>
                <img v-else src="../../../assets/images/agentManage/mine_no_active.png"/>
                <p>我的</p>
            </div>

        </div>
     </div>
</template>

<script>
export default {
    name: "footer",
    props: ['currentNav'],
    data () {
        return {
            currentNavText: localStorage.getItem("currentPromationNav") && localStorage.getItem("currentPromationNav"),

        };
    },
    components: {
        
    },

    computed: {
    },


    created(){

        setTimeout(() => {
            this.currentNavText = localStorage.getItem("currentPromationNav") && localStorage.getItem("currentPromationNav")
        }, 300);    

    },

    mounted(){
       
    },
    destroyed(){
        
    },

    methods: {
        jumpMineHandle() {
            localStorage.setItem("currentPromationNav",'mine')
            this.$router.push({
                path: '/promotionCenterMine',
            })          
        },

        jumpPromotionCenterHandle() {
            localStorage.setItem("currentPromationNav",'center')
            this.$router.push({
                path: '/promotionCenter',
            })           
        }    
    },



}

</script>


<style  scoped>
 @import "../asset/css/agentManage.css";
</style>

